export default "__VITE_ASSET__DGSFwqrg__"